import { default as mergeData } from '../../utilities/mergeSingleDataIntoArray';
import * as Constants from '../constants/';

const initialState = {
  isLoading: false,
  hasLoadedOnce: false,
  error: null,
  data: {
    catalogs: []
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_CATALOGS:
    case Constants.REQUEST_CREATE_CATALOG:
      return { ...state, isLoading: true, hasLoadedOnce: true };
    case Constants.RECEIVE_CATALOGS:
    case Constants.RECEIVE_CREATE_CATALOG:
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          ...action.data
        }
      };
    case Constants.RECEIVE_UPDATED_CATALOG:
      return {
        ...state,
        isLoading: false,
        data: mergeData(state.data, action.data, 'catalogs', 'catalog', 'id')
      };
    default:
      return state;
  }
}
